import { Story as GenericStory, Meta } from "@storybook/react";
import { Search, SearchIcon } from "lucide-react";
import React from "react";
import { createGlobalStyle } from "styled-components";
import { typographyMixin } from "../../../helpers";
import { noop } from "../../../utils";
import Flex from "../../Flex";
import { Typography } from "../../Typography";
import MultiSelect, { IMultiSelectProps } from "./Multiselect";

type TArgs = IMultiSelectProps<number, string, string, string>;
type Story = GenericStory<React.ComponentProps<typeof MultiSelect>>;

const GlobalStyle = createGlobalStyle`
	body {
		${typographyMixin("paragraph-small-regular")}
	}
`;

const group = "options";
const mockOptions = [
    { label: "one", value: 1, group },
    { label: "two", value: 2, group },
    { label: "three", value: 3, group },
    { label: "four", value: 4, group },
    { label: "five", value: 5, group },
    { label: "six", value: 6, group },
    { label: "seven", value: 7, group },
    { label: "eight", value: 8, group },
    { label: "nine", value: 9, group },
    { label: "ten", value: 10, group }
];

const commonArgs: TArgs = {
    options: mockOptions,
    optionGroups: [group],
    trackName: "Stories.Multiselect.TrackEvent",
    noResults: "No results",
    onChange: noop
};

export default {
    title: "Form Components/Multiselect",
    component: MultiSelect,
    args: commonArgs
} as Meta;

const Template: Story = args => {
    return (
        <Flex column width={500}>
            <GlobalStyle />
            <MultiSelect {...args} />
        </Flex>
    );
};

export const Default = Template.bind({});

export const WithCustomRenderer = Template.bind({});
WithCustomRenderer.args = {
    children: option => (
        <Flex column p={4}>
            <Typography variant="label-medium-semibold" color="text-primary-600">
                {option.label}
            </Typography>
        </Flex>
    )
};

export const WithLabelAndHelperText = Template.bind({});
WithLabelAndHelperText.args = {
    label: "Label",
    helperText: "Helper text"
};

export const WithIcon = Template.bind({});
WithIcon.args = {
    icon: <SearchIcon />,
    placeholder: "Search"
};

export const AsASearchField = Template.bind({});
AsASearchField.args = {
    placeholder: "Search",
    disabled: false,
    withoutArrow: true,
    icon: <Search size={16} />
};

export const WithError = Template.bind({});
WithError.args = {
    error: (
        <>
            Available quantity of Product 1 at BER2: <strong>2000</strong>
        </>
    )
};

export const WithErrorAsBoolean = Template.bind({});
WithErrorAsBoolean.args = {
    error: true
};

export const Disabled = Template.bind({});
Disabled.args = {
    disabled: true
};

export const NotFilterable = Template.bind({});
NotFilterable.args = {
    filterable: false
};

export const WithBubble = Template.bind({});
WithBubble.args = {
    withBubble: true,
    bubbleLabel: "Selected"
};
